import { Headset } from "lucide-react";
import React from "react";
import { SUPPORT_WORK_TYPE_COLORS } from "utils/supportWorkTypeColors";

const Support = ({ ...props }) => {
  return (
    <div
      style={{
        width: "23px",
        height: "20px",
        backgroundColor: SUPPORT_WORK_TYPE_COLORS.REQUEST,
        borderRadius: "3px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "3px",
      }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="#fff"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        class="lucide lucide-triangle-alert-icon lucide-triangle-alert"
      >
        <path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3" />
        <path d="M12 9v4" />
        <path d="M12 17h.01" />
      </svg>
    </div>
  );
};

export default Support;
